import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/auth.service';
import { canAccessDashboard } from 'src/app/core/dashboard.guard';
import {
  clearPostLoginRedirectState,
  consumeOfficeChangeSession,
  isNewUserSession,
  markOfficeChangeSession,
  markPostLoginRedirectApplied,
  markUserSession,
  shouldApplyPostLoginRedirect,
} from 'src/app/core/post-login-redirect.guard';
import {
  hasStoredSession,
  usesAppLogin,
} from 'src/app/core/root-redirect.guard';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { StorageService } from 'src/app/core/storage.service';
import { ChangeCurrency } from 'src/app/models/change-currency.model';
import { Constants } from 'src/app/models/constants';
import { IQrResponse } from 'src/app/models/IQrResponse.model';
import { PopupInterfaceNew } from 'src/app/models/popups.model';
import { QRToggle } from 'src/app/models/qr-toggle.model';
import { ChangeCurrencyService } from 'src/app/services/change-currency.service';
import { GetCurrencyService } from 'src/app/services/get-currency.service';
import { AUTH_SESSION } from 'src/app/core/auth-flow/tokens';
import { AuthSession } from 'src/app/core/auth-flow/auth-session';
import { PopupService } from 'src/app/services/popup.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { UserPasswordService } from 'src/app/services/user-password.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { environment } from '@base/environments/environment';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/app.state';
import { setLoggedUser } from '../../store/actions/logged-user.actions';
import { QRButton } from '../../models/qr-button.model';
import { Overlay } from '../../models/overlay.model';
import { QRIcon } from '../../models/qr-icon.model';
import { QRDropdown } from '../../models/qr-dropdown.model';
import { ListUsersLoggedUser } from '../../core/models/logged-user.model';
import { NodeId } from '../../directives/if-node-directive/if-node-show.directive';

interface WebModule {
  id: number;
  label: string;
  url: string;
  icon: string;
  roles: string[];
  jupiter: boolean;
  pro: boolean;
  security: boolean;
  module: boolean;
  subItems?: SubItem[];
  order: number;
}

interface WebModuleROW {
  id: number;
  label: string;
  url: string;
  icon: string;
  roles: string[];
  order: number;
}

interface SubItem {
  id: number;
  label: string;
  url: string;
  icon: string;
  jupiter: boolean;
  pro: boolean;
  security: boolean;
  module: boolean;
}

@Component({
  selector: 'app-private-layout',
  templateUrl: './private-layout.component.html',
  styleUrls: ['./private-layout.component.scss'],
})
export class PrivateLayoutComponent implements OnInit {
  loggedUserSubscription: Subscription | undefined;
  userSelectedSubscription: Subscription | undefined;
  loggedUser: LogedUser | undefined;
  userDisplayName: string = '-';
  officeName: string = '-';
  enablePopup: boolean = true;
  showMessageVar: boolean = false;
  webModules: WebModule[] = [];
  webModulesRow: WebModuleROW[] = [];
  URL_HOME: string = '/home';
  URL_SUPPORT: string = '/support';
  readonly URL_SUPPORT_CHAT = Constants.URL_SUPPORT_CHAT;
  readonly ICON_ACCOUNT_CIRCLE = Constants.ICONS.ACCOUNT_CIRCLE;
  readonly ICON_DASHBOARD = Constants.ICONS.DASHBOARD;
  readonly ICON_TIMELINE = Constants.ICONS.TIMELINE;
  readonly ICON_TUNE = Constants.ICONS.TUNE;
  readonly ICON_DOWNLOAD = Constants.ICONS.DOWNLOAD;
  readonly ICON_PERSONS = Constants.ICONS.PERSONS;
  readonly ICON_SWAP_HORIZ = Constants.ICONS.SWAP_HORIZ;
  readonly ICON_BANK = Constants.ICONS.BANK;
  readonly ICON_ASSIGNMENT = Constants.ICONS.ASSIGNMENT;
  readonly ICON_ANALYTICS = Constants.ICONS.ANALYTICS;
  readonly ICON_DESCRIPTION = Constants.ICONS.DESCRIPTION;
  readonly ICON_SETTINGS = Constants.ICONS.SETTINGS;
  readonly ICON_PASSWORD = Constants.ICONS.PASSWORD;
  readonly ICON_SUPPORT = Constants.ICONS.SUPPORT;
  readonly ICON_SUPPORT_AGENT = Constants.ICONS.SUPPORT_AGENT;
  readonly ICON_LOGOUT = Constants.ICONS.LOGOUT;
  readonly ICON_CAE = Constants.ICONS.SOLICITATE_CAE;
  readonly ICONS_RENDITIONS_BETA = Constants.ICONS.RENDITIONS_BETA;
  readonly ICONS_RECRUITMENT_BETA = Constants.ICONS.RECRUITMENT_MENU;
  readonly ICONS_QR_LEARNING = Constants.ICONS.QR_LEARNING;
  readonly ICON_AGENT = Constants.ICONS.AGENT;
  readonly ICON_RECRUITMENT = Constants.ICONS.RECRUITMENT_MENU;
  readonly ICON_EXPAND_MORE = Constants.ICONS.EXPAND_MORE;
  readonly ICON_EXPAND_LESS = Constants.ICONS.EXPAND_LESS;
  readonly ICON_CHART = Constants.ICONS.CHART;
  readonly ICON_INPUT = Constants.ICONS.INPUT;
  readonly ICON_NEW_PROPERTIES = Constants.ICONS.NEW_PROPERTIES;
  readonly ICON_HANDS = Constants.ICONS.HANDS;
  readonly ICON_LIST = Constants.ICONS.LIST;
  readonly ICON_RESERVOMETRO = Constants.ICONS.RESERVOMETRO;
  readonly ICON_RENDITION = Constants.ICONS.CLOSED_LISTING;
  readonly ICON_PROFIT = Constants.ICONS.PROFIT;
  readonly ICON_OFFICES = Constants.ICONS.OFFICES;
  readonly ICON_MAIN_DASH = Constants.ICONS.MAIN_DASH;
  readonly ICON_SYNC = Constants.ICONS.SYNC;
  readonly ICON_TOOLS = Constants.ICONS.TOOLS;
  readonly ICON_RANKING = Constants.ICONS.RANKING;
  readonly ICON_AGENTS_GROUP = Constants.ICONS.AGENTS_GROUP;
  readonly ICON_AI = Constants.ICONS.AI;

  //Constants Colors
  readonly COLOR_GREY_100 = QRIcon.COLOR_GREY_100;
  readonly COLOR_GREY_200 = QRIcon.COLOR_GREY_200;
  readonly COLOR_GREY_400 = QRIcon.COLOR_GREY_400;
  readonly COLOR_GREY_500 = QRIcon.COLOR_GREY_500;
  readonly COLOR_PRIMARY_300 = QRIcon.COLOR_PRIMARY_300;
  readonly ICON_TABLE_CHART = Constants.ICONS.TABLE_CHART;

  readonly NODE = environment.node;
  readonly NODE_AR = Constants.TENANT_ID_AR;
  readonly NODE_EC = Constants.TENANT_ID_EC;
  // AR, DO, EC y PY usan el menú nuevo agrupado; el resto sigue con el menú antiguo
  readonly USES_NEW_MENU: boolean = usesAppLogin();
  readonly NODE_PY = Constants.TENANT_ID_PY;
  readonly NODE_UY = Constants.TENANT_ID_UY;
  readonly NODE_DO = Constants.TENANT_ID_DO;
  readonly NODE_GLOBAL = Constants.TENANT_ID_GLOBAL;

  /** Resolves the "Gastos y rentabilidad" target for the current node. */
  readonly expensesAndProfitUrl = Constants.EXPENSES_AND_PROFIT_NODES.includes(
    environment.node,
  )
    ? '/reports'
    : environment.oldFrontUrl + '/reports';

  URL_CONFIGURATION: string = '/configuration';
  visibleMenuUser: boolean = false;

  toggleCurrency: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_1,
    size: QRToggle.SIZE_SMALL,
    viewValues: [Constants.INTERNATIONAL_CURRENCY, Constants.LOCAL_CURRENCY],
    optionSelected: 0,
  };

  currencySelected: string | undefined;
  showPopup: boolean | null = null;
  popupData: PopupInterfaceNew | undefined;
  inhabilitateLayout: boolean = false;
  enablePasswordUpdatePopup: boolean = false;
  multiOfficeDropdown: QRDropdown = {
    hierarchy: QRDropdown.HIERARCHY_1,
    size: QRDropdown.SIZE_SMALL,
    options: [],
    placeholder: 'Seleccionar oficina',
  };

  multiOfficeDropdownSelected: string | undefined = undefined;

  userLoaded = false;
  currencyLoaded = false;
  itemExpand: number | null = null;
  manualExpand = false;
  preventHoverExpand = false;
  isHovered = false;

  //-------------------- Dialog Configurations--------------------
  isChangePasswordVisible: boolean = false;
  showChangePasswordComponent: boolean = true;

  overlayChangePassword: Overlay = {
    isButtonCloseVisible: false,
    isFullHeight: false,
    doesClickingOutsideContentClose: false,
  };

  btnCancel: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Cancelar',
  };

  btnSaveChangePassword: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Guardar',
  };

  isButtonSaveDisabled: boolean = true;
  oldPass: string = '';
  newPass: string = '';
  repeatNewPass: string = '';

  constructor(
    private readonly authService: AuthenticationService,
    private readonly router: Router,
    @Inject(AUTH_SESSION) private readonly authSession: AuthSession,
    private readonly userSessionService: UserSessionService,
    private readonly changeCurrencyService: ChangeCurrencyService,
    private readonly getCurrencyService: GetCurrencyService,
    private readonly snackbarService: SnackbarService,
    private readonly sessionStorageService: StorageService,
    private readonly popupService: PopupService,
    private readonly cookieService: CookieService,
    private readonly userPasswordService: UserPasswordService,
    private readonly store: Store<AppState>,
  ) {}

  ngOnInit(): void {
    this.validateLoggedUser();

    this.loggedUserSubscription = this.userSessionService.loggedUser$.subscribe(
      (loggedUser) => {
        if (loggedUser != null) {
          this.userDisplayName = loggedUser.name;
          this.officeName = loggedUser.agency_name;
          if (this.webModules.length == 0) {
            // Detecto que no se cargaron los web modules, los genero;
            this.loggedUser = loggedUser;
          }
          setTimeout(() => {
            this.getCurrencySelected();
          }, 100);

          this.store.dispatch(setLoggedUser({ loggedUser: loggedUser }));
        }

        // If the user exists
        if (this.loggedUser) {
          // Then we set enable-password-update-popup variable to what the service says.
          // 0 means it needs to be updated.

          if (!this.loggedUser.reset) {
            this.isChangePasswordVisible = true;
          }
          if (this.loggedUser.listUsers.length > 1) {
            this.formatMultiOffice(this.loggedUser);
          }
        }
      },
    );

    this.userSelectedSubscription =
      this.userSessionService.userSelected$.subscribe((userSelected) => {
        // Al cambiar de oficina/usuario (listUsers)
        if (userSelected != null) {
          this.userDisplayName = userSelected.userFullName;
        }
      });
  }

  formatMultiOffice(loggedUser: LogedUser): void {
    const AGENCY_NAME = this.multiOfficeDropdownSelected
      ? this.multiOfficeDropdownSelected
      : loggedUser.agency_name;
    this.multiOfficeDropdown.options = [];
    loggedUser.listUsers.forEach((agency) => {
      agency.agencyName === AGENCY_NAME
        ? this.multiOfficeDropdown.options.unshift(agency.agencyName)
        : this.multiOfficeDropdown.options.push(agency.agencyName);
    });
    this.multiOfficeDropdownSelected = AGENCY_NAME;
  }

  multiOfficeDropdownChange(selected: string | string[] | undefined): void {
    if (selected) {
      this.multiOfficeDropdownSelected = selected.toString();
      const FIND = this.loggedUser?.listUsers.find(
        (user) => user.agencyName == selected.toString(),
      );
      if (FIND) {
        this.changeUser(FIND);
      } else {
        this.snackbarService.openSnackBar(
          'Oficina no encontrada. Contacte a soporte.',
          'error',
        );
      }
    }
  }

  changeUser(data: ListUsersLoggedUser) {
    this.authSession
      .switchOffice(data)
      .then(() => {
        this.router
          .navigateByUrl('/', { skipLocationChange: true })
          .then(() => {
            window.location.reload();
          });
      })
      .catch(() => {
        this.snackbarService.openSnackBar(
          'Error al cambiar de oficina. Contacte a soporte.',
          'error',
        );
      });
  }

  // changeUser(data: ListUsersLoggedUser) {
  //   const URL = data.agencyId.toString();
  //   this.changeUserService.get(URL).then((response: any) => {
  //     if (response) {
  //       const MODULES: string[] = [];
  //       for (var moduleId in response.modulesAssign) {
  //         MODULES.push(moduleId);
  //       }

  //       const USER: LogedUser = {
  //         username: data.user,
  //         pro: data.pro,
  //         lite: data.lite,
  //         agency_id: data.agencyId,
  //         agency_region: data.agencyRegion,
  //         currency: data.currency,
  //         currencyLabel: data.currencyLabel,
  //         agency_name: data.agencyName,
  //         iListAgency: data.iListAgency,
  //         agency_modules: MODULES,
  //         name: data.userFullName,
  //         id: data.user,
  //         role: data.rol,
  //         rolName: data.rolName,
  //         token: data.token,
  //         security: data.security,
  //         message: data.message,
  //         title: data.title,
  //         haveMessage: data.haveMessage,
  //         closable: data.closable,
  //         jupiter: data.jupiter,
  //         email: data.email,
  //         reset: data.reset,
  //         office: data.office,
  //         listUsers: this.loggedUser?.listUsers ?? [],
  //         secret: this.loggedUser?.secret ?? '',
  //         showInCurrency: data.showInCurrency,
  //       };

  //       this.store.dispatch(setLoggedUser({ loggedUser: USER }));
  //       this.userSessionService.loggedUser = USER;
  //       this.sessionStorageService.removeSessionStorage(
  //         UserSessionService.LOGGED_USER
  //       );
  //       this.sessionStorageService.setObjectSessionStorage(
  //         UserSessionService.LOGGED_USER,
  //         USER
  //       );
  //       this.router.navigate([this.URL_HOME]);
  //     } else {
  //       this.snackbarService.openSnackBar(
  //         'Error al cambiar de oficina. Contacte a soporte.',
  //         'error'
  //       );
  //     }
  //   });
  // }

  //Basicaly this function is to give a priority oprder to popups, particularly Password change popup and (as a sub-category of regular popups) locked office popup. In case both appear, password popup is more important than locked office.

  getPopupData(agencyId: number, userRole: number) {
    this.popupService
      .getPopupsList()
      .then((response: any) => {
        if (response?.data) {
          const res = response.data;
          res.forEach((element: PopupInterfaceNew) => {
            if (
              element?.agencies.find(
                (element: number) => element == agencyId,
              ) &&
              (userRole == element.rol || element.rol == -1) &&
              this.showMessageVar
            ) {
              this.showPopup = true;
              this.popupData = element;

              if (this.popupData) {
                // This mostrarCerrar truth validation is working as a mirror in purpose to give the right value to inhabilitateLayout
                this.inhabilitateLayout = this.popupData.mostrarCerrar != 'SI';
              }
            }
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  getLoggedUser(): void {
    const LOGGED_USER_JSON: string | null = localStorage.getItem(
      UserSessionService.LOGGED_USER,
    );
    this.userLoaded = true;

    if (LOGGED_USER_JSON) {
      const loggedUser: LogedUser | undefined = JSON.parse(LOGGED_USER_JSON);
      this.loggedUser = loggedUser;
      this.showPopup = localStorage.getItem('showMessage') == 'true';
      this.showMessageVar = localStorage.getItem('showMessage') == 'true';

      if (this.USES_NEW_MENU) {
        this.generateItems();
      } else {
        this.generateModules();
      }
    } else {
      this.showPopup = localStorage.getItem('showMessage') == 'true';
      this.loggedUser = undefined;
    }

    if (this.loggedUser) {
      this.getPopupData(this.loggedUser.agency_id, this.loggedUser.role);
    }
  }

  private applyPostLoginRedirect(user: LogedUser): void {
    const TARGET = canAccessDashboard(user) ? '/dashboard' : this.URL_HOME;
    const CURRENT_PATH = this.router.url.split('?')[0];

    if (CURRENT_PATH === TARGET || CURRENT_PATH.startsWith(`${TARGET}/`)) {
      return;
    }

    void this.router.navigateByUrl(TARGET);
  }

  validateLoggedUser(): void {
    this.authSession
      .restoreSession()
      .then((response: LogedUser) => {
        this.userSessionService.loggedUser = response;

        if (consumeOfficeChangeSession()) {
          markUserSession(response);
          markPostLoginRedirectApplied();
          this.getLoggedUser();
          return;
        }

        const IS_NEW_SESSION = isNewUserSession(response);

        if (IS_NEW_SESSION) {
          markUserSession(response);
        }

        this.getLoggedUser();

        if (shouldApplyPostLoginRedirect(response)) {
          markPostLoginRedirectApplied();
          this.applyPostLoginRedirect(response);
        }
      })
      .catch(() => {
        // No stored session means the user never logged in (or logged out): go to login, not session-expired
        const HAD_SESSION = hasStoredSession();
        this.userSessionService.userSelected = null;
        localStorage.removeItem('showMessage');
        localStorage.removeItem('messagesId');
        localStorage.removeItem('currentUser');
        clearPostLoginRedirectState();
        this.router.navigate([
          usesAppLogin() && !HAD_SESSION ? 'login' : 'session-expired',
        ]);
      });
  }

  ngOnDestroy(): void {
    this.loggedUserSubscription?.unsubscribe();
    this.userSelectedSubscription?.unsubscribe();
  }
  listenForPasswordUpdate(event: boolean) {
    this.enablePasswordUpdatePopup = false;
    this.enablePopup = event;
  }

  changeMessageStatus(event: boolean) {
    if (this.loggedUser) {
      this.showPopup = false;
      this.sessionStorageService.setObjectSessionStorage(
        UserSessionService.LOGGED_USER,
        this.loggedUser,
      );
    }
  }

  logout(): void {
    this.authService.logout();
  }

  // GENERADOR DE MODULOS PARA EC-PY
  generateModules(): void {
    let webModules: WebModuleROW[] = [];
    this.loggedUser?.agency_modules.forEach((id: string) => {
      let idModule = Number(id);
      let webModule: WebModuleROW;
      switch (idModule) {
        case 3: // 3) Dashboard
          webModule = {
            id: idModule,
            label: 'Dashboard',
            url:
              (this.NODE == this.NODE_EC || this.NODE == this.NODE_PY
                ? environment.oldFrontUrl
                : '') + '/dashboard',
            icon: this.ICON_DASHBOARD,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_ADMINISTRATOR_2,
              Constants.ROLE_BROKER,
            ],
            order: 1,
          };
          if (this.loggedUser?.security.dashboard) {
            webModules.push(webModule);
          }
          break;
        case 4: // 4) RRHH
          webModule = {
            id: idModule,
            label: 'RRHH',
            url: '/rrhh',
            icon: this.ICON_PERSONS,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_BROKER,
              Constants.ROLE_MANAGER,
              Constants.ROLE_SECRETARY,
              Constants.ROLE_ADMINISTRATOR_2,
              Constants.ROLE_SECRETARY_2,
            ],
            order: 4,
          };
          if (this.loggedUser?.security.rrhh) {
            webModules.push(webModule);
          }
          break;
        case 6: // 6) Movimientos
          webModule = {
            id: idModule,
            label: 'Movimientos',
            url:
              this.NODE === this.NODE_AR || this.NODE === this.NODE_DO
                ? '/movimientos'
                : environment.oldFrontUrl + '/movements',
            icon: this.ICON_SWAP_HORIZ,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_ADMINISTRATOR_2,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
            ],
            order: 5,
          };
          if (this.loggedUser?.security.movements) {
            webModules.push(webModule);
          }
          break;
        case 7: // 7) Ctas. Ctes.
          webModule = {
            id: idModule,
            label: 'Ctas. Ctes.',
            url:
              this.NODE === this.NODE_AR || this.NODE === this.NODE_EC || this.NODE === this.NODE_PY || this.NODE === this.NODE_DO
                ? '/cuentas-corrientes'
                : environment.oldFrontUrl + '/ctasctes',
            icon: this.ICON_BANK,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 6,
          };
          webModules.push(webModule);

          break;
        case 8: // 8) Rendición
          webModule = {
            id: idModule,
            label: 'Rendición',
            url:
              this.NODE == this.NODE_AR ||
              this.NODE === this.NODE_GLOBAL ||
              this.NODE === this.NODE_DO
                ? '/renditions'
                : environment.oldFrontUrl + '/rendicion',
            icon:
              this.NODE == this.NODE_AR
                ? this.ICONS_RENDITIONS_BETA
                : this.ICON_ASSIGNMENT,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 7,
          };
          if (this.loggedUser?.security.renditions) {
            webModules.push(webModule);
          }

          break;
        case 9: // 9) Estadísticas
          webModule = {
            id: idModule,
            label: 'Estadísticas',
            url: environment.oldFrontUrl + '/stats',
            icon: this.ICON_ANALYTICS,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_SECRETARY,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
              Constants.ROLE_SECRETARY_2,
            ],
            order: 8,
          };
          if (this.loggedUser?.security.statistics) {
            webModules.push(webModule);
          }
          break;
        case 10: // 10) Reportes
          webModule = {
            id: idModule,
            label: 'Reportes',
            url: this.expensesAndProfitUrl,
            icon: this.ICON_DESCRIPTION,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 9,
          };
          if (this.loggedUser?.security.reports && this.loggedUser?.security.reports_pyl) {
            webModules.push(webModule);
          }
          break;
        case 11: // 11) Main Dash y Ranking
          {
            let webModuleiDash: WebModuleROW = {
              id: idModule,
              label: 'Main Dash',
              url: environment.oldFrontUrl + '/ilistdashboard#',
              icon: this.ICON_TUNE,
              roles: [
                Constants.ROLE_ADMINISTRATOR,
                Constants.ROLE_MANAGER,
                Constants.ROLE_BROKER,
                Constants.ROLE_SECRETARY,
                Constants.ROLE_ADMINISTRATOR_2,
                Constants.ROLE_SECRETARY_2,
              ],
              order: 2,
            };
            let webModuleRanking: WebModuleROW = {
              id: idModule,
              label: 'Ranking',
              url: '/ranking',
              icon: this.ICON_TIMELINE,
              roles: [
                Constants.ROLE_ADMINISTRATOR,
                Constants.ROLE_MANAGER,
                Constants.ROLE_BROKER,
                Constants.ROLE_SECRETARY,
                Constants.ROLE_ADMINISTRATOR_2,
                Constants.ROLE_SECRETARY_2,
              ],
              order: 3,
            };
            if (this.loggedUser?.security.ilist) {
              if (this.NODE != this.NODE_EC && this.NODE != this.NODE_PY)
                webModules.push(webModuleiDash);
              webModules.push(webModuleRanking);
            }
          }
          break;

        case 15: // 10) Afip
          webModule = {
            id: idModule,
            label: 'Facturación Electrónica',
            url: '/billing',
            icon: this.ICON_CAE,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_ADMINISTRATOR_2,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
            ],
            order: 10,
          };
          //Este modulo no se ve en ecuador ni paraguay provisoriamente
          if (
            this.loggedUser?.security.afip_invoice &&
            this.NODE != this.NODE_EC &&
            this.NODE != this.NODE_PY
          ) {
            webModules.push(webModule);
          }

          break;
        case 14: // 7) Downloads
          webModule = {
            id: idModule,
            label: 'Descargas',
            url: '/downloads',
            icon: this.ICON_DOWNLOAD,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 13,
          };
          //Este modulo no se ve en ecuador ni paraguay provisoriamente
          webModules.push(webModule);
          break;

        case 17: // 7) Reclutamiento BETA
          webModule = {
            id: idModule,
            label: 'Reclutamiento',
            url: '/beta/recruitment',
            icon: this.ICONS_RECRUITMENT_BETA,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 11,
          };
          if (
            this.loggedUser?.security.recruitment &&
            (this.NODE != this.NODE_AR ||
              (this.NODE == this.NODE_AR && this.loggedUser?.pro) ||
              this.loggedUser.jupiter)
          ) {
            webModules.push(webModule);
          }
          break;

        case 19: // Generador de xml uif
          webModule = {
            id: idModule,
            label: 'Generador de xml UIF',
            url: '/generador-xml-uif',
            icon: this.ICON_TABLE_CHART,
            roles: [
              Constants.ROLE_ADMINISTRATOR,
              Constants.ROLE_MANAGER,
              Constants.ROLE_BROKER,
              Constants.ROLE_ADMINISTRATOR_2,
            ],
            order: 14,
          };
          if (
            this.NODE === this.NODE_AR &&
            this.loggedUser?.security.generate_xml
          ) {
            webModules.push(webModule);
          }
          break;
      }
    });

    const WEB_MODULE = {
      id: -1,
      label: 'QR Learning',
      url: this.generateLearningLink(this.NODE),
      icon: this.ICONS_QR_LEARNING,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      order: 11,
    };

    if (this.NODE !== this.NODE_GLOBAL) {
      webModules.push(WEB_MODULE);
    }

    const SORTED_MODULES = [...webModules].sort((a, b) => a.order - b.order);
    this.webModulesRow = SORTED_MODULES;
  }

  // GENERADOR DE MODULOS PARA AR - REP DOM
  generateItems(): void {
    if (!this.loggedUser) return;

    const SECURITY = this.loggedUser?.security ?? {};

    const AGENCY_MODULES = this.loggedUser.agency_modules;

    // --- RR.HH ---
    const RRHH_MODULES: WebModule[] = [];

    const AGENTS = {
      id: -10,
      label: 'Agentes',
      url: '/rrhh',
      icon: this.ICON_AGENT,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      order: 1,
      security: SECURITY.rrhh,
      module: AGENCY_MODULES.includes('4'),
    };

    const RECRUITMENT = {
      id: 17,
      label: 'Reclutamiento',
      url: '/beta/recruitment',
      icon: this.ICONS_RECRUITMENT_BETA,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      order: 2,
      jupiter: false,
      pro: true,
      security: SECURITY.recruitment ?? false,
      module: AGENCY_MODULES.includes('17'),
    };

    RRHH_MODULES.push(AGENTS);

    RRHH_MODULES.push(RECRUITMENT);

    const RRHH_MODULE = {
      id: 4,
      label: 'RR.HH.',
      url: 'rrhh',
      subItems: RRHH_MODULES,
      icon: this.ICON_PERSONS,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_BROKER,
        Constants.ROLE_MANAGER,
        Constants.ROLE_SECRETARY,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_SECRETARY_2,
      ],
      jupiter: false,
      pro: false,
      order: 1,
      security: SECURITY?.rrhh,
      module: AGENCY_MODULES.includes('4'),
    };

    this.webModules.push(RRHH_MODULE);

    // --- ADMINISTRACIÓN & FINANZAS ---
    let adminModule: WebModule[] = [];

    const CTAS_CTES_MODULE = {
      id: 7,
      label: 'Ctas. Ctes.',
      url:
        this.NODE === this.NODE_AR || this.NODE === this.NODE_EC || this.NODE === this.NODE_PY || this.NODE === this.NODE_DO
          ? '/cuentas-corrientes'
          : environment.oldFrontUrl + '/ctasctes',
      icon: this.ICON_BANK,
      roles: [Constants.ROLE_ADMINISTRATOR, Constants.ROLE_ADMINISTRATOR_2],
      jupiter: false,
      pro: true,
      order: 1,
      security: SECURITY.cuentas_ctes,
      module: AGENCY_MODULES.includes('7'),
    };

    adminModule.push(CTAS_CTES_MODULE);

    const MOVEMENTS_MODULE = {
      id: 6,
      label: 'Movimientos',
      url: '/movimientos',
      icon: this.ICON_SWAP_HORIZ,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.movements,
      module: AGENCY_MODULES.includes('6'),
      order: 2,
    };

    adminModule.push(MOVEMENTS_MODULE);

    const GASTOS_MODULE = {
      id: 10,
      label: 'Gastos y rentabilidad',
      url: this.expensesAndProfitUrl,
      icon: this.ICON_CHART,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.reports && SECURITY.reports_pyl,
      module: AGENCY_MODULES.includes('10'),
      order: 3,
    };

    adminModule.push(GASTOS_MODULE);

    const ELECTRONIC_BILLING = {
      id: 15,
      label: 'Facturación Electrónica',
      url: '/billing',
      icon: this.ICON_CAE,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
      ],
      jupiter: true,
      pro: false,
      security: SECURITY.afip_invoice,
      module: AGENCY_MODULES.includes('15'),
      order: 3,
    };

    //Este modulo no se ve en ecuador ni paraguay provisoriamente
    if (
      this.NODE !== this.NODE_EC &&
      this.NODE !== this.NODE_PY &&
      this.NODE !== this.NODE_DO
    ) {
      adminModule.push(ELECTRONIC_BILLING);
    }

    const ADMIN_MODULES = [...adminModule].sort((a, b) => a.order - b.order);

    const ADMIN_MODULE = {
      id: 99,
      label: 'Administración & Finanzas',
      url: 'admin',
      icon: this.ICON_BANK,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: true,
      module: true,
      order: 2,
      subItems: ADMIN_MODULES,
    };

    this.webModules.push(ADMIN_MODULE);

    // --- OPERACIONES ---
    const OPERATION_MODULES: WebModule[] = [];

    // AGREGAR GESTOR CUANDO TENGAMOS LAS VALIDACIONES DE SEGURIDAD
    const SYNC_MODULE = {
      id: -1,
      label: 'Sync',
      url: '/sync',
      icon: this.ICON_SYNC,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: true,
      pro: false,
      security: SECURITY.sync,
      module: AGENCY_MODULES.includes('18'),
      order: 1,
    };

    const IMPORTADOR = {
      id: -2,
      label: 'Importar captaciones',
      url: '/importador-de-captaciones',
      icon: this.ICON_INPUT,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: true,
      pro: false,
      security: SECURITY.statistics,
      module: AGENCY_MODULES.includes('9'),
      order: 2,
    };

    OPERATION_MODULES.push(IMPORTADOR);

    if (this.NODE === this.NODE_AR) {
      OPERATION_MODULES.push(SYNC_MODULE);
    }

    const AGREGAR_CAPTACION = {
      id: -3,
      label: 'Agregar captación',
      url: '/nueva-captacion',
      icon: this.ICON_NEW_PROPERTIES,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics && SECURITY.statistics_cap_res_list,
      module: AGENCY_MODULES.includes('9'),
      order: 3,
    };

    OPERATION_MODULES.push(AGREGAR_CAPTACION);

    const AGREGAR_RESERVA = {
      id: -4,
      label: 'Agregar reserva',
      url: '/nueva-reserva',
      icon: this.ICON_HANDS,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics && SECURITY.statistics_cap_res_list,
      module: AGENCY_MODULES.includes('9'),
      order: 4,
    };

    OPERATION_MODULES.push(AGREGAR_RESERVA);

    const LISTADO = {
      id: -5,
      label: 'Listado',
      url: '/listado',
      icon: this.ICON_LIST,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics && SECURITY.statistics_cap_res_list,
      module: AGENCY_MODULES.includes('9'),
      order: 5,
    };

    OPERATION_MODULES.push(LISTADO);

    const RESERVOMETRO = {
      id: -18,
      label: 'Reservómetro',
      url: '/reservometro',
      icon: this.ICON_RESERVOMETRO,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics && SECURITY.statistics_reserv_stats,
      module: AGENCY_MODULES.includes('9'),
      order: 6,
    };

    OPERATION_MODULES.push(RESERVOMETRO);

    const RENDITIONS_MODULE = {
      id: 8,
      label: 'Rendiciones',
      url:
        this.NODE === this.NODE_AR ||
        this.NODE === this.NODE_GLOBAL ||
        this.NODE === this.NODE_DO
          ? '/renditions'
          : environment.oldFrontUrl + '/rendicion',
      icon: this.ICON_RENDITION,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: SECURITY.renditions,
      module: AGENCY_MODULES.includes('8'),
      order: 7,
    };

    OPERATION_MODULES.push(RENDITIONS_MODULE);

    const OPERATION_MODULE = [...OPERATION_MODULES].sort(
      (a, b) => a.order - b.order,
    );

    const OPERATIONS_MODULE = {
      id: 100,
      label: 'Operaciones',
      url: 'operaciones',
      icon: this.ICON_ASSIGNMENT,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: true,
      module: true,
      order: 2,
      subItems: OPERATION_MODULE,
    };

    this.webModules.push(OPERATIONS_MODULE);

    // --- ESTADÍSTICAS ---
    const STATISTICS_MODULES: WebModule[] = [];

    const DASHBOARD = {
      id: 3,
      label: 'Dashboard',
      url: '/dashboard',
      icon: this.ICON_DASHBOARD,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_BROKER,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.dashboard,
      module: AGENCY_MODULES.includes('3'),
      order: 1,
    };

    STATISTICS_MODULES.push(DASHBOARD);

    const RANKING_MODULE: WebModule = {
      id: 24,
      label: 'Ranking de oficinas',
      url: '/ranking',
      icon: this.ICON_TIMELINE,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_SECRETARY,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_SECRETARY_2,
      ],
      jupiter: false,
      pro: false,
      security: SECURITY.ilist,
      module: AGENCY_MODULES.includes('11'),
      order: 2,
    };

    if (
      this.NODE === this.NODE_DO ||
      this.NODE === this.NODE_EC ||
      this.NODE === this.NODE_PY
    ) {
      STATISTICS_MODULES.push(RANKING_MODULE);
    }

    const RANKING_UNIFIED_MODULE: WebModule = {
      id: 11,
      label: 'Ranking unificado',
      url: '/ranking-unificado',
      icon: this.ICON_RANKING,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_SECRETARY,
        Constants.ROLE_ADMINISTRATOR_2,
        Constants.ROLE_SECRETARY_2,
      ],
      jupiter: false,
      pro: false,
      security: SECURITY.ilist,
      module: AGENCY_MODULES.includes('11'),
      order: 2,
    };

    if (this.NODE === this.NODE_AR) {
      STATISTICS_MODULES.push(RANKING_UNIFIED_MODULE);
    }

    const RRHH_STATS = {
      id: -6,
      label: 'Estadísticas RR.HH.',
      // Mismos nodos que habilita RrhhStatsComponent.validateSecurity()
      url: [this.NODE_AR, this.NODE_EC, this.NODE_PY].includes(this.NODE)
        ? '/rrhh-stats'
        : environment.oldFrontUrl + '/rrhh/stats',
      icon: this.ICON_PERSONS,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: true,
      pro: false,
      security: SECURITY.rrhh_stats,
      module: AGENCY_MODULES.includes('4'),
      order: 3,
    };

    STATISTICS_MODULES.push(RRHH_STATS);

    // agregar nuevo security newAngular
    const RESUME_OFFICE = {
      id: -7,
      label: 'Resumen oficina',
      url: '/resumen-oficinas',
      icon: this.ICON_OFFICES,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics,
      module: AGENCY_MODULES.includes('9'),
      order: 4,
    };

    const RESUME_AGENTE = {
      id: -8,
      label: 'Resumen agente',
      url: '/resumen-agentes',
      icon: this.ICON_AGENT,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: SECURITY.statistics,
      module: AGENCY_MODULES.includes('9'),
      order: 5,
    };

    const RESUME_TEAMS = {
      id: -9,
      label: 'Resumen teams',
      url: '/resumen-teams',
      icon: this.ICON_AGENTS_GROUP,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: true,
      pro: true,
      security: SECURITY.statistics,
      module: AGENCY_MODULES.includes('9'),
      order: 5,
    };

    STATISTICS_MODULES.push(RESUME_OFFICE);
    STATISTICS_MODULES.push(RESUME_AGENTE);

    if (this.NODE === this.NODE_AR) {
      STATISTICS_MODULES.push(RESUME_TEAMS);
    }

    const STATISTICS_MODULE = [...STATISTICS_MODULES].sort(
      (a, b) => a.order - b.order,
    );

    const STATS_MODULE = {
      id: 101,
      label: 'Estadísticas',
      url: 'stats',
      icon: this.ICON_PROFIT,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: true,
      module: true,
      order: 3,
      subItems: STATISTICS_MODULE,
    };

    this.webModules.push(STATS_MODULE);

    // --- AI ---
    const AI_MODULE = {
      id: 103,
      label: 'QR IA',
      url:
        this.loggedUser?.pro || this.loggedUser?.jupiter
          ? '/qr-ia'
          : '/inteligencia-artificial',
      icon: this.ICON_AI,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      lite: false,
      jupiter: true,
      pro: true,
      security: true,
      module: true,
      order: 4,
    };

    // const AI_MODULE = {
    //   id: 103,
    //   label: 'QR IA',
    //   url: '/inteligencia-artificial',
    //   icon: this.ICON_AI,
    //   roles: [
    //     Constants.ROLE_ADMINISTRATOR,
    //     Constants.ROLE_MANAGER,
    //     Constants.ROLE_BROKER,
    //     Constants.ROLE_ADMINISTRATOR_2,
    //   ],
    //   jupiter: false,
    //   pro: false,
    //   security: SECURITY.ia,
    //   module: true,
    //   order: 4,
    // };

    if (this.NODE === this.NODE_AR) {
      this.webModules.push(AI_MODULE);
    }
    // --- HERRAMIENTAS ---

    const TOOLS_MODULES: WebModule[] = [];

    const GENERATOR_XML_UIF = {
      id: -9,
      label: 'Generador de xml UIF',
      url: '/generador-xml-uif',
      icon: this.ICON_TABLE_CHART,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: true,
      pro: false,
      security: SECURITY.generate_xml,
      order: 14,
      module: true,
    };
    if (this.NODE === this.NODE_AR && this.loggedUser?.security.generate_xml) {
      TOOLS_MODULES.push(GENERATOR_XML_UIF);
    }

    const TOOL_MODULE = {
      id: 102,
      label: 'Herramientas',
      url: '/tools',
      icon: this.ICON_TOOLS,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: true,
      security: true,
      module: true,
      order: 4,
      subItems: TOOLS_MODULES,
    };

    if (this.NODE === this.NODE_AR && this.loggedUser?.security.generate_xml) {
      this.webModules.push(TOOL_MODULE);
    }

    // --- DESCARGAS ---

    const DOWNLOAD_MODULE = {
      id: 14,
      label: 'Descargas',
      url: '/downloads',
      icon: this.ICON_DOWNLOAD,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: true,
      module: AGENCY_MODULES.includes('14'),
      order: 12,
    };

    this.webModules.push(DOWNLOAD_MODULE);

    // --- LEARNING ---
    const LEARNING_MODULE = {
      id: -1,
      label: 'QR Learning',
      url: this.generateLearningLink(this.NODE),
      icon: this.ICONS_QR_LEARNING,
      roles: [
        Constants.ROLE_ADMINISTRATOR,
        Constants.ROLE_MANAGER,
        Constants.ROLE_BROKER,
        Constants.ROLE_ADMINISTRATOR_2,
      ],
      jupiter: false,
      pro: false,
      security: true,
      module: true,
      order: 13,
    };

    if (this.NODE !== this.NODE_GLOBAL) {
      this.webModules.push(LEARNING_MODULE);
    }
  }

  isConfigVisible(): boolean {
    let isVisible: boolean = false;
    if (this.loggedUser?.security.agency_conf) isVisible = true;
    return isVisible;
  }

  isModuleActive(url: string): boolean {
    const CURRENT_URL = this.router.url;

    if (this.urlMatchesRoute(CURRENT_URL, url)) {
      return true;
    }

    const MODULE = this.webModules.find((m) => m.url === url);

    if (MODULE?.subItems) {
      return MODULE.subItems.some((sub) =>
        this.urlMatchesRoute(CURRENT_URL, sub.url),
      );
    }

    return false;
  }

  /** Exact path or child segment; avoids '/rrhh' matching '/rrhh-stats'. */
  private urlMatchesRoute(currentUrl: string, moduleUrl: string): boolean {
    if (!moduleUrl?.startsWith('/')) {
      return false;
    }
    const PATH = currentUrl.split('?')[0];
    return PATH === moduleUrl || PATH.startsWith(moduleUrl + '/');
  }

  getMainModuleHref(module: WebModule): string | null {
    // Decide si el ítem principal del menú debe tener un href real o no.
    if (module.id === -1 || module.id === 14) {
      return module.url;
    }

    if (!module.subItems?.length && module.url?.startsWith('/')) {
      return module.url;
    }

    return null;
  }

  onModuleClickEcPyGl(module: WebModuleROW, event: MouseEvent): void {
    if (environment.production && this.NODE === this.NODE_EC) {
      const DTO = {
        modulo: module.label,
        seccion: module.label,
        user_role: this.loggedUser?.rolName,
        region: this.NODE,
      };

      gtag('event', 'menu_click', {
        ...DTO,
        transport_type: 'beacon',
      });
    }

    // --- TIENE PERMISOS
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      window.open(module.url, '_blank');
      return;
    }

    // Click normal
    window.location.href = module.url;
  }

  onMainModuleLinkClick(module: WebModule, event: MouseEvent): void {
    // Maneja el click en ese <a> cuando sí hay href.
    const HREF = this.getMainModuleHref(module);

    if (!HREF || module.id === -1) {
      return;
    }

    if (event.ctrlKey || event.metaKey || event.button === 1) {
      return;
    }

    event.preventDefault();

    if (environment.production) {
      const DTO = {
        modulo: module.label,
        seccion: module.label,
        user_role: this.loggedUser?.rolName,
        region: this.NODE,
      };

      gtag('event', 'menu_click', {
        ...DTO,
        transport_type: 'beacon',
      });
    }

    if (HREF.startsWith('http')) {
      window.location.href = HREF;
      return;
    }

    this.router.navigateByUrl(HREF);
  }

  // Pro users on DO, EC and PY can open Jupiter features.
  private get isJupiterOpenToPro(): boolean {
    return (
      this.NODE === this.NODE_DO ||
      this.NODE === this.NODE_EC ||
      this.NODE === this.NODE_PY
    );
  }

  hasPermission(module: SubItem): boolean {
    if (module.jupiter && this.loggedUser?.pro && !this.isJupiterOpenToPro)
      return false;
    if (module.pro && this.loggedUser?.lite) return false;
    if (module.jupiter && this.loggedUser?.lite) return false;
    if (!module.module || !module.security) return false;
    return true;
  }

  onSubItemClick(
    module: SubItem,
    event: MouseEvent,
    parentModule: WebModule,
  ): void {
    event.preventDefault();

    // --- EVALUAMOS PERMISOS ---
    let errorMessage: string | null = null;

    if (module.jupiter && this.loggedUser?.pro && !this.isJupiterOpenToPro) {
      errorMessage =
        'Esta funcionalidad forma parte de la versión Pro +. Actualizá tu plan para comenzar a utilizarla.';
    } else if (module.pro && this.loggedUser?.lite) {
      errorMessage =
        'Esta funcionalidad forma parte de la versión Pro. Actualizá tu plan para comenzar a utilizarla.';
    } else if (module.jupiter && this.loggedUser?.lite) {
      errorMessage =
        'Esta funcionalidad forma parte de la versión Pro +. Actualizá tu plan para comenzar a utilizarla.';
    } else if (!module.module || !module.security) {
      errorMessage =
        'Para habilitar esta funcionalidad, contactá al administrador del sistema de tu oficina.';
    }

    // --- SI NO TIENE PERMISOS → MOSTRAMOS MENSAJE Y BLOQUEAMOS TODO ---
    if (errorMessage) {
      this.snackbarService.openWithVariableDuration(errorMessage, '', 4000);
      return;
    }

    if (environment.production) {
      const DTO = {
        modulo: parentModule.label,
        seccion: module.label,
        user_role: this.loggedUser?.rolName,
        region: this.NODE,
      };

      gtag('event', 'menu_click', {
        ...DTO,
        transport_type: 'beacon',
      });
    }

    // --- TIENE PERMISOS
    if (event.ctrlKey || event.metaKey || event.button === 1) {
      window.open(module.url, '_blank');
      return;
    }

    // Click normal
    window.location.href = module.url;
  }

  generateLearningLink(node: string): string {
    let url = '';
    if (this.loggedUser) {
      const SPLIT_NAME = this.loggedUser.name.split(' ');
      const FIRST_NAME = SPLIT_NAME[0] ?? '';
      let lastName = '';
      for (let index = 1; index < SPLIT_NAME.length; index++) {
        lastName =
          index == 1
            ? lastName + SPLIT_NAME[index]
            : lastName + ' ' + SPLIT_NAME[index];
      }
      const ROLE = this.loggedUser.role == 5 ? 'broker' : 'staff';
      url = `https://learning.qrsolutions.com.ar/wp-json/qr/v1/login?identifier=${this.loggedUser.id}&email=${this.loggedUser.email}&type=${ROLE}&country=${node}&first_name=${FIRST_NAME}&last_name=${lastName}`;
    }
    return url;
  }

  getCurrencySelected(): void {
    if (this.loggedUser?.id) {
      let user: { user: string } = {
        user: this.loggedUser?.id,
      };
      // Ecuador no necesita identificar su moneda, es siempre usd
      if (this.NODE == this.NODE_EC) {
        this.currencySelected = Constants.CURRENCY_DOLLAR;
        this.userSessionService.currencySelected = Constants.CURRENCY_DOLLAR;
        this.currencyLoaded = true;
      } else {
        this.getCurrencyService
          .postNoId(user)
          .then((response) => {
            this.currencyLoaded = true;
            let dataResponse: IQrResponse<ChangeCurrency> = response.body;
            this.currencySelected = dataResponse.data.currency;
            this.userSessionService.currencySelected = this.currencySelected; // Se guarda la moneda en almacenamiento de sesión
          })
          .finally(() => {
            this.setToggleCurrency();
          });
      }
    }
  }

  setToggleCurrency(): void {
    switch (this.currencySelected) {
      case Constants.CURRENCY_DOLLAR:
        this.toggleCurrency = {
          ...this.toggleCurrency,
          optionSelected: 0,
        };
        break;
      case Constants.CURRENCY_PESOS_ARS:
      case Constants.CURRENCY_PESOS_UYU:
      case Constants.CURRENCY_PESOS_PYG:
        this.toggleCurrency = {
          ...this.toggleCurrency,
          optionSelected: 1,
        };
        break;
      // TODO: Moneda de Bolivia
    }
  }

  toggleCurrencyChange(option: number): void {
    this.currencySelected = Constants.CURRENCY_DOLLAR;
    if (option != 0) {
      let currencyNode = '';

      switch (this.NODE) {
        case this.NODE_AR:
        case this.NODE_GLOBAL:
        case this.NODE_DO:
          currencyNode = Constants.CURRENCY_PESOS_ARS;
          break;
        case this.NODE_UY:
          currencyNode = Constants.CURRENCY_PESOS_UYU;
          break;
        case this.NODE_PY:
          currencyNode = Constants.CURRENCY_PESOS_PYG;
          break;
      }
      this.currencySelected = currencyNode;
    }

    if (this.loggedUser?.id) {
      let changeCurrecy: ChangeCurrency = {
        user: this.loggedUser?.id,
        currency: this.currencySelected,
      };

      this.changeCurrencyService
        .postNoId(changeCurrecy)
        .then(() => {})
        .finally(() => {
          this.userSessionService.currencySelected = this.currencySelected;
          if (this.currencySelected === 'ARS' && this.NODE === this.NODE_DO) {
            this.snackbarService.openSnackBar(
              'Se ha cambiado la moneda a DOP',
              '',
            );
          } else {
            this.snackbarService.openSnackBar(
              'Se ha cambiado la moneda a ' + this.currencySelected,
              '',
            );
          }

          if (this.currencySelected) {
            this.cookieService.set('selectedCurrency', this.currencySelected, {
              domain: environment.currencyCookieDomain,
            });
          }
          setTimeout(() => {
            location.reload();
          }, 300);
        });
    }
  }

  changePassword() {
    this.isChangePasswordVisible = true;
  }

  onChangePassword($event: any) {
    if ($event == 'disabled') {
      this.isButtonSaveDisabled = true;
      return;
    }

    const IS_VALID_CHANGE =
      $event &&
      typeof $event === 'object' &&
      'oldPass' in $event &&
      'newPass' in $event &&
      'repetNewPass' in $event;

    if (IS_VALID_CHANGE) {
      this.isButtonSaveDisabled = false;
      this.oldPass = $event.oldPass;
      this.newPass = $event.newPass;
      this.repeatNewPass = $event.repetNewPass;
    }
  }

  savePasswordChange() {
    this.userPasswordService
      .changePassword(this.oldPass, this.newPass, this.repeatNewPass)
      .then((res: any) => {
        if (res) this.snackbarService.openSnackBar(res.message, '');
        this.isChangePasswordVisible = false;
        this.showChangePasswordComponent = false;
        setTimeout(() => {
          this.showChangePasswordComponent = true;
        });
      });
  }

  closeChangePasswordOverlay() {
    this.isChangePasswordVisible = false;
    this.showChangePasswordComponent = false;

    setTimeout(() => {
      this.showChangePasswordComponent = true;
    });
  }

  closeMenuConfig() {
    this.visibleMenuUser = false;
  }

  toggleExpand(index: number): void {
    const MODULE = this.webModules[index];
    if (!MODULE?.subItems?.length) {
      return;
    }

    // Si el usuario hace click en el mismo módulo abierto → colapsar
    if (this.itemExpand === index) {
      this.itemExpand = null;
      this.manualExpand = false;
      this.preventHoverExpand = true;
      return;
    }

    // Si hace click en otro módulo → abrimos
    this.itemExpand = index;
    this.manualExpand = true;
    this.preventHoverExpand = false;
  }

  getSubMenuHeight(index: number): number {
    const MODULE = this.webModules[index];
    if (!MODULE.subItems) return 0;

    if (this.itemExpand === index) {
      return MODULE.subItems.length * 48;
    }

    if (
      !this.manualExpand &&
      !this.preventHoverExpand &&
      this.isHovered &&
      this.isModuleActive(MODULE.url)
    ) {
      this.itemExpand = index;
      return MODULE.subItems.length * 48;
    }

    return 0;
  }

  onSidebarEnter(): void {
    this.isHovered = true;
    this.preventHoverExpand = false;
  }

  onSidebarLeave(): void {
    this.itemExpand = null;
    this.isHovered = false;
    this.manualExpand = false;
    this.preventHoverExpand = false;
  }

  isNewAngularEnabledForNode = (
    node: NodeId,
    newAngularFlag: boolean,
  ): boolean => {
    const NEW_ANGULAR_ALWAYS_ON = new Set([this.NODE_AR, this.NODE_DO]); // AR está disponible siempre
    const OFFICE_RESUME_NEW_ANGULAR_NODES = new Set([
      this.NODE_DO,
      this.NODE_AR,
      this.NODE_EC,
      this.NODE_PY,
    ]);

    if (!OFFICE_RESUME_NEW_ANGULAR_NODES.has(node)) return false;

    // Argentina no depende del flag
    if (NEW_ANGULAR_ALWAYS_ON.has(node)) return true;

    // Resto de regiones dependen del flag
    return !!newAngularFlag;
  };
}
